import React from 'react';

function FormHtmlField(props) {
    return (
        <div className="FormField full" dangerouslySetInnerHTML={{__html: props.HTML}} />
    )
}

export default FormHtmlField;